import { useInfiniteQuery } from '@tanstack/react-query';

import { nhatKyRepository } from '../../../lib/repositories/nhat-ky.repository';
import { GIOI_HAN_TRANG } from '../nghiep-vu/khoang';
import type { LocAudit, TrangAudit } from '../types';

/**
 * Nhật ký thao tác của một tenant, phân trang con trỏ 50 dòng.
 *
 * `loc` phải ổn định giữa các lần vẽ: khoảng thời gian tính từ một mốc `neo`
 * chỉ đổi khi người dùng bấm, không từ `Date.now()` mỗi lần render — nếu không
 * khoá truy vấn đổi liên tục và danh sách tải lại không dứt.
 *
 * `bat = false` khi bộ lọc chưa hợp lệ (khoảng tuỳ chọn ngược chiều, quá 90 ngày).
 */
export function useNhatKy(loc: LocAudit | null, nenTang: boolean) {
  return useInfiniteQuery<TrangAudit>({
    queryKey: ['nhat-ky', nenTang ? 'nen-tang' : 'tenant', loc],
    queryFn: ({ pageParam }) =>
      nhatKyRepository.trang(loc!, pageParam as string | null, GIOI_HAN_TRANG, nenTang),
    initialPageParam: null,
    getNextPageParam: (trang) => trang.next_cursor,
    enabled: loc !== null,
    staleTime: 30_000,
  });
}
